import { withType } from "../../../utils/actionOperations";
import { RENDER_PDF_RESET } from "../../constants";

export const resetReportData = () => {
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_RESET, {}));
  };
};
